














































import { Component, Prop, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import Headline from '@/components/layout/Headline.vue'
import Bilderreihe from '@/components/layout/Bilderreihe.vue'
@Component({
  components: { Headline, Bilderreihe }
})
export default class Gebaeudereinigung extends Vue {}
